<template>
    <div class="emp-card" :key="`emp-${employeeId}`">
        <DxDataGrid :data-source="dsContracteMunca" ref="dataGridRef" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-auto-width="false" :show-borders="true" key-expr="Id">
            <DxSelection mode="single" />
            <DxFilterRow :visible="false" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxScrolling mode="standard" :show-scrollbar="'always'" />
            <DxColumnFixing :enabled="true" />
            <DxEditing :allow-updating="true" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="700" :height="450"
                    :show-title="false">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="saveButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
            </DxEditing>
            <DxColumn data-field="TransferInRevisal" width="150" />
            <DxColumn data-field="StareCurenta" width="150" />
            <DxColumn data-field="CorId" width="170" caption="COR Cod" />
            <DxColumn data-field="CorVersiune" width="110" caption="COR Versiune" />
            <DxColumn data-field="DataConsemnare" width="130" />
            <DxColumn data-field="DataCreare" width="100" />
            <DxColumn data-field="DataIncepereActivitate" width="140" />
            <DxColumn data-field="DataIncheiereContract" width="140" />
            <DxColumn data-field="DateContractVechi" width="140" />
            <DxColumn data-field="Detalii" width="100" />
            <DxColumn data-field="AngajatorSursaCui" width="100" />
            <DxColumn data-field="AngajatorSursaDenumire" width="100" />
            <DxColumn data-field="DataImport" width="100" />
            <DxColumn data-field="TipMutare" width="100" />
            <DxColumn data-field="ExceptieDataSfarsit" width="100" />
            <DxColumn data-field="NumarContract" width="100" />
            <DxColumn data-field="NumereContractVechi" width="100" />
            <DxColumn data-field="Radiat" width="100" />
            <DxColumn data-field="SalariuBrut" width="100" />
            <DxColumn data-field="SporTipNume" width="100" />
            <DxColumn data-field="TimpMuncaNorma" width="100" />
            <DxColumn data-field="TimpMuncaRepartizare" width="100" />
            <DxColumn data-field="TimpMuncaIntervalTimp" width="100" />
            <DxColumn data-field="TimpMuncaDurata" width="100" />
            <DxColumn data-field="TipContract" width="100" />
            <DxColumn data-field="TipNorma" width="100" />
            <DxColumn data-field="DataReactivare" width="100" />
            <DxColumn data-field="EchipamentIndividualProtectie" width="100" />
            <DxColumn data-field="EchipamentIndividualLucru" width="100" />
            <DxColumn data-field="MaterialeIgienicoSanitare" width="100" />
            <DxColumn data-field="AlimentatieProtectie" width="100" />
            <DxColumn data-field="AlteDrepturiObligatiiSsm" width="100" />
            <DxColumn data-field="NumarContractColectivMunca" width="100" />
            <DxColumn data-field="DataIncheiereContractColectiv" width="100" />
            <DxColumn data-field="SeriePermisMunca" width="100" />
            <DxColumn data-field="NumarPermisMunca" width="100" />
            <DxColumn data-field="DataPermisMunca" width="100" />
            <DxColumn data-field="LocatiaDesfasurariiActivitatii" width="100" />
            <DxColumn data-field="NrLuniActivitate" width="100" />
            <DxColumn data-field="ConcediuOdihnaSuplimentar" width="100" />
            <DxColumn data-field="DataPlataSalariu" width="100" />
            <DxColumn data-field="PerioadaProba" width="100" />
            <DxColumn data-field="TipPreaviz" width="100" />
            <DxColumn data-field="PerioadaPreaviz" width="100" />
            <DxToolbar>
                <!-- Butonul "Vezi pagina de contracte" – DOAR când nu e ruta Contracte -->
                <DxItem location="before" v-if="$route.name !== 'Contracte'">
                    <template #default>
                        <button class="continue-application" @click="goToContracts">
                            <div>
                                <div class="folder">
                                    <div class="top">
                                        <svg viewBox="0 0 24 27">
                                            <path d="M0 0h24v27H0z"></path>
                                        </svg>
                                    </div>
                                    <div class="paper"></div>
                                </div>
                                <div class="pencil"></div>
                            </div>
                            Vezi pagina de contracte
                        </button>
                    </template>
                </DxItem>
                
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Înapoi" icon="arrowleft"  type="default"
                            class="back-button" @click="goBack" />
                    </template>
                </DxItem>
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Corecție"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Suspendare"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Detașare"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                 <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Schimb. Loc Munca"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                 <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Încetare/Reactivare"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Istoric"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>
                 <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="L153"  type="default"
                            class="back-button"  />
                    </template>
                </DxItem>

                <DxItem location="after">
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                
            </DxToolbar>
        </DxDataGrid>
        <DxPopupAdd :visible="addPopupVisible" :show-title="true" :height="450" :width="700">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <DxForm :col-count="2" :data-source="formData" label-alignment="center">
                <DxSimpleItem data-field="CourseCpv" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="addButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import { DxScrollView } from 'devextreme-vue/scroll-view';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSearchPanel,
    DxScrolling,
    DxColumnFixing
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import DxPopupView from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import PER_Meserii from '@/services/PER/PER_Meserii';


export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxScrolling,
        DxColumnFixing,
        DxScrollView,
        DxPopupView
    },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(id) {
                if (!id || !this.$refs.dataGridRef?.instance) return;
                const ds = this.$refs.dataGridRef.instance.getDataSource();
                ds.filter(["AngajatId", "=", id]);
                ds.load();
            }
        }
    },
    data() {
        return {
            isDetailsVisible: false,
            dsContracteMunca: {} as DataSource,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            editPopupVisible: false,
            selectContracte: {} as any,
            formData: {
                Id: null,
                AngajatId: null,
                NumarContract: null,
                TipContract: null,
                DataIncepereActivitate: null,
                DataIncheiereContract: null,
                TipNorma: null,
                SalariuBrut: null,
                CorId: null,
                DataCim: null,
                DataConsemnare: null,
                Detalii: null,
                ExceptieDataSfarsit: null,
                NumereContractVechi: null,
                Radiat: null,
                SporTipNume: null,
                StareCurentaId: null,
                TimpMuncaDurata: null,
                TimpMuncaIntervalTimp: null,
                CorVersiune: null,
                StareCurenta: null,
                TimpMuncaNorma: null,
                TimpMuncaRepartizare: null,
                AngajatorSursaCui: null,
                AngajatorSursaDenumire: null,
                DataImport: null,
                TipMutare: null,
                DataReactivare: null,
                TipDurata: null,
                TransferInRevisal: false,
                EchipamentIndividualProtectie: null,
                EchipamentIndividualLucru: null,
                MaterialeIgienicoSanitare: null,
                AlimentatieProtectie: null,
                AlteDrepturiObligatiiSsm: null,
                NumarContractColectivMunca: null,
                DataIncheiereContractColectiv: null,
                SeriePermisMunca: null,
                NumarPermisMunca: null,
                DataPermisMunca: null,
                NrLuniActivitate: null,
                LocatiaDesfasurariiActivitatii: null,
                ConcediuOdihnaSuplimentar: null,
                DataPlataSalariu: null,
                PerioadaProba: null,
                TipPreaviz: null,
                PerioadaPreaviz: null,
                EsteIstoric: false,
                DetaliiMutare: null,
                SporIsProcent: null,
                SporTip: null,
                SporTipVersiune: null,
                SporValoare: null,
                UserCreare: null,
                DataCreare: null,
                UserModificare: null,
                DataModificare: null,
                ContractReferintaId: null,
                EmploymentTypeId: null,
                AaNr: null,
                AaData: null,
                AaValabilDeLa: null,
                AaValabilPanaLa: null,
                DateContractVechi: null
            },
            addButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:880px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        }
    },

    mounted() {
        this.dsContracteMunca = new DataSource({
            store: new ODataStore({
                version: 4,
                url: AppSetting.API_Url_ResurseUmaneOdata + "RU_ContracteDeMunca",
                key: "Id",
                fieldTypes: { Id: "Guid", AngajatId: "Guid" },
                beforeSend: e => {
                    e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                }
            }),
            // setez filtrul inițial aici
            filter: ["AngajatId", "=", this.employeeId]
        });
    },
    methods: {
        onViewDetails(e) {
            const rowData = e?.row?.data;
            if (rowData) {
                this.showDetails(rowData);
            }
        },
        showDetails(contracte: any) {

            this.selectContracte = {
                ...contracte,

            };
            this.isDetailsVisible = true;
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return;
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onSaveAdd() {
            if (!this.newMeserie.name || this.newMeserie.name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 2000)
                return
            }
            if (!this.newMeserie.code || this.newMeserie.code.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 2000)
                return
            }
            PER_Meserii.save(this.newMeserie).then((meserie) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newMeserie = {
                    name: '',
                    code: '',
                    Active: false,
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 2000);
            })
        },
        onCloseAdd() {
            this.addPopupVisible = false

        },
        goToContracts() {
            this.$router.push({
                name: 'Contracte',
                params: { id: this.employeeId }
            });
        },
         goBack() {
            this.$router.back()
            this.$emit('back')
        }
        ,


    },
})
</script>
<style>
.back-button {
    background-color: #f5f5f5 !important;
    color: #1f1e1e !important;
    border: 1px solid #ccc !important;
    border-radius: 4px !important;
    padding: 10px 18px !important;
    margin: 10px !important;
    /* spațiu exterior */
    transition: all 0.2s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.back-button:hover {
    background-color: #f34f26 !important;
    transform: translateX(-3px);
}

/* forțăm afișarea săgeții mereu */
.back-button .dx-icon {
    display: inline-block !important;
    font-size: 30px;
    opacity: 1 !important;
    visibility: visible !important;
    margin-right: 2px;
    color: #1f1e1e !important;
}
.back-button .dx-button-content .dx-icon {
    font-size: 12px !important;
    color: #1f1e1e !important;
    display: inline-block !important;
    opacity: 1 !important;
    margin-right: 6px;
}



/* From Uiverse.io by Nawsome */
.continue-application {
    --color: #fff;
    --background: #ffffff;
    --background-hover: #dfe1eb;
    --background-left: #ffffff;
    --folder: #F3E9CB;
    --folder-inner: #BEB393;
    --paper: #FFFFFF;
    --paper-lines: #BBC1E1;
    --paper-behind: #E1E6F9;
    --pencil-cap: #fff;
    --pencil-top: #fe7627;
    --pencil-middle: #fff;
    --pencil-bottom: #f19914;
    --shadow: rgba(187, 107, 33, 0.2);
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    -webkit-tap-highlight-color: transparent;
    padding: 15px 20px 10px 60px;
    color: #525151;
    background: #fff;
}

.continue-application>div {
    top: 0;
    left: 0;
    bottom: 0;
    width: 53px;
    position: absolute;
    overflow: hidden;
    border-radius: 5px 0 0 5px;
    background: var(--background-left);
}

.continue-application>div .folder {
    width: 23px;
    height: 27px;
    position: absolute;
    left: 15px;
    top: 13px;
}

.continue-application>div .folder .top {
    left: 0;
    top: 0;
    z-index: 2;
    position: absolute;
    transform: translateX(var(--fx, 0));
    transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application>div .folder .top svg {
    width: 24px;
    height: 27px;
    display: block;
    fill: var(--folder);
    transform-origin: 0 50%;
    transition: transform 0.3s ease var(--fds, 0.45s);
    transform: perspective(120px) rotateY(var(--fr, 0deg));
}

.continue-application>div .folder:before,
.continue-application>div .folder:after,
.continue-application>div .folder .paper {
    content: "";
    position: absolute;
    left: var(--l, 0);
    top: var(--t, 0);
    width: var(--w, 100%);
    height: var(--h, 100%);
    border-radius: 1px;
    background: var(--b, var(--folder-inner));
}

.continue-application>div .folder:before {
    box-shadow: 0 1.5px 3px var(--shadow), 0 2.5px 5px var(--shadow), 0 3.5px 7px var(--shadow);
    transform: translateX(var(--fx, 0));
    transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application>div .folder:after,
.continue-application>div .folder .paper {
    --l: 1px;
    --t: 1px;
    --w: 21px;
    --h: 25px;
    --b: var(--paper-behind);
}

.continue-application>div .folder:after {
    transform: translate(var(--pbx, 0), var(--pby, 0));
    transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application>div .folder .paper {
    z-index: 1;
    --b: var(--paper);
}

.continue-application>div .folder .paper:before,
.continue-application>div .folder .paper:after {
    content: "";
    width: var(--wp, 14px);
    height: 2px;
    border-radius: 1px;
    transform: scaleY(0.5);
    left: 3px;
    top: var(--tp, 3px);
    position: absolute;
    background: var(--paper-lines);
    box-shadow: 0 12px 0 0 var(--paper-lines), 0 24px 0 0 var(--paper-lines);
}

.continue-application>div .folder .paper:after {
    --tp: 6px;
    --wp: 10px;
}

.continue-application>div .pencil {
    height: 2px;
    width: 3px;
    border-radius: 1px 1px 0 0;
    top: 8px;
    left: 105%;
    position: absolute;
    z-index: 3;
    transform-origin: 50% 19px;
    background: var(--pencil-cap);
    transform: translateX(var(--pex, 0)) rotate(35deg);
    transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application>div .pencil:before,
.continue-application>div .pencil:after {
    content: "";
    position: absolute;
    display: block;
    background: var(--b, linear-gradient(var(--pencil-top) 55%, var(--pencil-middle) 55.1%, var(--pencil-middle) 60%, var(--pencil-bottom) 60.1%));
    width: var(--w, 5px);
    height: var(--h, 20px);
    border-radius: var(--br, 2px 2px 0 0);
    top: var(--t, 2px);
    left: var(--l, -1px);
}

.continue-application>div .pencil:before {
    -webkit-clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
    clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
}

.continue-application>div .pencil:after {
    --b: none;
    --w: 3px;
    --h: 6px;
    --br: 0 2px 1px 0;
    --t: 3px;
    --l: 3px;
    border-top: 1px solid var(--pencil-top);
    border-right: 1px solid var(--pencil-top);
}

.continue-application:before,
.continue-application:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: var(--color);
    transform-origin: 9px 1px;
    transform: translateX(var(--cx, 0)) scale(0.5) rotate(var(--r, -45deg));
    top: 26px;
    right: 16px;
    transition: transform 0.3s;
}

.continue-application:after {
    --r: 45deg;
}

.continue-application:hover {
    --cx: 2px;
    --bg: var(--background-hover);
    --fx: -40px;
    --fr: -60deg;
    --fd: .15s;
    --fds: 0s;
    --pbx: 3px;
    --pby: -3px;
    --pbd: .15s;
    --pex: -24px;
}

.circle-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 12px;
    height: 12px;
}

.circle-true {
    background-color: #4caf50;
    color: white;
}

.circle-false {
    background-color: #e71010;
}

.activity-details-container {
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #444;
    margin: 15px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.activity-info-item {
    display: flex;
    margin: 8px 0;
}

.info-label {
    font-weight: 600;
    color: #555;
    width: 100px;
}

.info-value {
    color: #333;
    flex: 1;
}

.view-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: row;

    .grid {
        .name-template {

            .position {
                font-size: 12px;
                color: var(--texteditor-label-color);
            }
        }

        :deep(.dx-datagrid-header-panel) {
            padding: 0 var(--content-padding);

        }

        :deep(.dx-datagrid-content .dx-row) {
            cursor: pointer;
        }


    }
}

.edit-cell {
    position: relative;

    activity-status {
        position: absolute;
        margin-top: 10px;
        margin-left: 11px;
    }
}
</style>